import React from "react";

function Section1() {
  return (
    <section className="hero_section">
      <img src="../assets/images/home/banner.jpg" alt="Hero Banner" />
    </section>
  );
}
export default Section1;
